// @flow

import React from 'react';
import PropTypes from 'prop-types';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Grid } from '@material-ui/core';

import './style.css';

type PropsAppTable = {
    children: any
};

type PropsRow = {
    data: any,
    keys: any
};

type PropsHeader = {
    HeaderValue: any
};

function RenderRow(props: PropsRow) {
    const { data, keys } = props;
    return keys.map((key, index) => {
        return (
            <TableCell key={data[key] + index}>
                <div dangerouslySetInnerHTML={{ __html: data[key] }}></div>
            </TableCell>
        );
    });
}

function HeaderData(props: PropsHeader) {
    const { HeaderValue } = props;
    return (
        <TableCell key={HeaderValue}>
            {HeaderValue.includes('-')
                ? HeaderValue.toUpperCase().replace('-', ' ')
                : HeaderValue.toUpperCase()}
        </TableCell>
    );
}

function AppTable(props: PropsAppTable) {
    const { children } = props;

    function getKeys() {
        return children.length >= 2 ? Object.keys(children[0]) : '';
    }

    function getHeader() {
        return children.length >= 2
            ? Object.keys(children[0]).map((key, i) => (
                <HeaderData HeaderValue={key} key={i} />
            ))
            : Object.keys(children).map((key, i) => (
                <HeaderData HeaderValue={key} key={i} />
            ));
    }

    function getRowsData() {
        var items = children;
        var keysRow = getKeys();

        return children.length >= 2 ? (
            items.map((row, index) => {
                return (
                    <TableRow key={index}>
                        <RenderRow key={index} data={row} keys={keysRow} />
                    </TableRow>
                );
            })
        ) : (
            <TableRow key={1}>
                {Object.keys(items).map((key, i) => (
                    <TableCell key={i}><div dangerouslySetInnerHTML={{ __html: items[key] }}></div> </TableCell>
                ))}
            </TableRow>
        );
    }

    return (
        <Grid container>
            <Table className="table-body">
                <TableHead>
                    <TableRow>{getHeader()}</TableRow>
                </TableHead>
                <TableBody>{getRowsData()}</TableBody>
            </Table>
        </Grid>
    );
}

AppTable.propTypes = {
    children: PropTypes.any,
    data: PropTypes.array,
    keys: PropTypes.array
};

export default AppTable;
